<template>
    <table>
        <thead>
            <tr v-if="showHeader" class="text-left text-md font-semibold text-gray-700">
                <th class="pb-2">
                    Quantity
                </th>
                <th class="pb-2 pl-5">
                    <div class="flex items-center">
                        <span>
                            Size
                        </span>
                        <u-tooltip v-if="isApproximateMeasurement" class="ml-2 inline-flex">
                            <i class="fa fa-info-circle cursor-help text-yellow-600 hover:text-yellow-700"></i>
                            <template #popper>
                                These measurements are approximate and can vary
                                between bricks in this batch
                            </template>
                        </u-tooltip>
                    </div>
                </th>
                <th v-if="SHOW_PRICE" class="pb-2 pl-5">
                    Price
                </th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(product) in products" :key="`${product.type}-${product.id}`">
                <td class="pr-4 align-top">
                    <input v-model="products[product.id].quantity" type="number" name="quantity" min="0"
                           @input="validateQuantity(product.id)"
                        class="border border-gray-300 rounded-md px-3 py-2 my-1 w-20 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        :disabled="sample === 'true'">
                </td>
                <td>
                    <slot name="product-info" :product="product"/>
                </td>
                <td v-if="SHOW_PRICE" class="align-top text-right">
                    {{ getPricePerBrick(product) }}
                    <div class="text-gray-400 text-xs">
                        per brick
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    props: {
        parent: {
            type: Object,
            required: true,
        },
        products: {
            type: Object,
            required: true,
        },
        sample: {
            type: String,
            required: false,
            default: "false",
        },
        isApproximateMeasurement: {
            type: Boolean,
            required: true,
        },
        showHeader: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    data() {
        return {
            // Debs wants this hidden for now, since they're not yet selling brick variations
            SHOW_PRICE: false,
            qtyAvailable: this.parent.meta.quantity,
        };
    },
    methods: {
        getPricePerBrick(product) {
            return Number(product?.pricing?.per_brick / 100).toLocaleString('en-GB', {
                style: 'currency',
                currency: 'GBP'
            });
        },
        validateQuantity(productId) {
            if (this.sample === "true") {
                if (this.products[productId].quantity > 1) {
                    this.products[productId].quantity = 1;
                }
                return;
            }

            const quantity = this.products[productId].quantity;
            if (quantity > this.qtyAvailable) {
                this.products[productId].quantity = this.qtyAvailable;
            }
        }
    },
};
</script>
